import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'

/**
 * Returns the discount of a product, formatted as a string.
 *
 * @param product - The CrossSellProduct to get the discount for.
 *
 * @example
 * const discount = crossSellAccessorGetProductDiscount(product)
 * @returns The discount as a string, or undefined if the product is not discounted.
 */
export const cartIntermediateCrossSellAccessorGetProductDiscount = (
  product: CrossSellProduct,
): string | undefined => {
  return product.reduced === 'true'
    ? `−${product.ersparnis_prozent_text.replaceAll(' ', '')}`
    : undefined
}
